import { Layout } from "../components/Layout";
import { Bell, Database, Shield, Smartphone } from "lucide-react";

export default function CorporateSettings() {
  return (
    <Layout variant="corporate">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Corporate</div>
        <h1 className="text-3xl font-bold text-navy">Settings</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="settings-grid">
        <SettingCard icon={Database} title="Data sync" desc="vAuto feed refreshes every 15 minutes. Last successful sync: moments ago." />
        <SettingCard icon={Bell} title="Alert thresholds" desc="Strong Buy ≥ 85 · Buy ≥ 70 · Conditional ≥ 55 · Pass < 55" />
        <SettingCard icon={Shield} title="User management" desc="Corporate admins can provision GMs, UCMs, and buyers per rooftop. SSO for @ourisman.com coming soon." />
        <SettingCard icon={Smartphone} title="Notifications" desc="Twilio SMS · Slack · Email — currently stubbed to in-app toasts for demo." />
      </div>
    </Layout>
  );
}

function SettingCard({ icon: Icon, title, desc }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-8 h-8 rounded-md bg-navy text-white flex items-center justify-center">
          <Icon size={16} />
        </div>
        <h3 className="font-bold text-navy">{title}</h3>
      </div>
      <p className="text-sm text-slate-600 font-medium">{desc}</p>
    </div>
  );
}
